<template>
  <div>
    <div class="mail-box-header">
      <div class="row">
        <div class="col-lg-6">
          <div class="input-group col-lg-12">
            <input
              type="text"
              class="form-control"
              placeholder="Tolerancia"
              v-model="continuousTolerance"
            />
          </div>
        </div>
        <div class="col-lg-6">
          <div class="input-group-btn col-lg-12">
            <button
              type="button"
              class="btn btn-sm btn-primary"
              @click="relateWithDefaultClient"
              :disabled="!selectedSchedule"
            >
              <i class="fa fa-send"></i>
              Relacionar como padão
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'DefaultClient',
  props: {
    selectedSchedule: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      continuousTolerance: '',
    };
  },

  methods: {
    async relateWithDefaultClient() {
      try {
        await this.$store.dispatch('RELATE/RelateClient', {
          tariffScheduleId: this.selectedSchedule,
          continuousTolerance: this.continuousTolerance || null,
        });
        this.$toasted.success('Cliente relacionado com sucesso!');
      } catch (error) {
        this.$toasted.error('Não foi possível relacionar cliente');
      }
    },
  },
};
</script>